import { FormattedMessage } from 'react-intl';
import React from 'react';

const fileUploadErrorsCheck = (uploadData) => {
  return [...uploadData?.parsingResult, ...uploadData?.storingResult].reduce((output, item) => {
    if (!item.success) {
      output.push(item.errorMessage);
    }
    return output;
  }, []);
};

export const handleUploadResult = (importData, importError, setSuccessMessage, setErrorMessage, setRefresh) => {
  importData &&
    (() => {
      const errors = fileUploadErrorsCheck(importData);
      if (errors.length > 0) {
        setErrorMessage(errors.map((errorMessage, index) => <div key={index}>{errorMessage}</div>));
      } else {
        setSuccessMessage(<FormattedMessage id={'app.import.success'} />);
        setRefresh(true);
      }
    })();

  importError?.data?.error && setErrorMessage(importError?.data?.message);
};
